module.exports = __webpack_public_path__ + "media/images/pic/tree-96003a56b5d0215542c3bb0bd43fc384.png";